import { CirclePlus } from 'lucide-react';

import { TIPOS_BONUS } from '../bonus.api';
import { BonusSolicitudesPage } from './bonus-solicitudes-page';

/**
 * Bonus → Acumular (`/bonus/acumular`).
 *
 * Puerto de `Bonus::accumulate`: las acumulaciones de puntos
 * (`loyalty/api/v2/Accumulate`) registradas por el flujo de venta.
 */
export function BonusAcumularPage() {
  return (
    <BonusSolicitudesPage
      eyebrow="Bonus"
      titulo="Acumular"
      descripcion="Acumulaciones de puntos registradas contra el servicio de Bonus, con el detalle enviado y la respuesta de Primax."
      tipo={TIPOS_BONUS.acumular}
      mostrarEnviados
      icono={CirclePlus}
    />
  );
}
